<template>
  <div class="row mt-5">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">

          <!-- Invitation to first appointment -->
          <router-link
              v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_HEAD_OF_AMDL' ||
                  currentUserRole === 'ROLE_PRACTICE_MANAGER' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER'"
              :to="{ name: 'privateCoachingInvitationToFirstAppointmentList', params: { id: coaching.id } }"
              :class="{ active: $route.name === 'privateCoachingInvitationToFirstAppointmentList' }"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            Einladungsschreiben
          </router-link>

          <!-- First Interview -->
          <!-- FOR BSG -->
          <div v-if="companyKey === 'BSG'">
            <router-link v-if="
              operationType !== 'modular_integration_coaching' &&
              operationType !== 'go_work_mobile' &&
              operationType !== 'potential_check'"
             :to="{ name: 'privateCoachingFirstInterviewForm', params: { id: coaching.id } }"
             :class="{ active: $route.name === 'privateCoachingFirstInterviewForm' }"
             class="nav-item nav-link"
             role="tab"
             aria-controls="nav-profile"
             aria-selected="false">
              Erstgespräch
            </router-link>

            <router-link
                v-else-if="operationType === 'go_work_mobile'"
                :to="{ name: 'privateCoachingGoWorkMobileFirstInterviewForm', params: { id: coaching.id } }"
                :class="{ active: $route.name === 'privateCoachingGoWorkMobileFirstInterviewForm' }"
                class="nav-item nav-link"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false">
              Erstgespräch
            </router-link>

            <div v-if="operationType === 'modular_integration_coaching'">
              <router-link
                  v-if="isMICNewLogic"
                  :to="{ name: 'privateCoachingMicFirstInterviewV2Form', params: { id: coaching.id } }"
                  :class="{ active:
                 $route.name === 'privateCoachingMicFirstInterviewV2Form' }"
                  class="nav-item nav-link"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false">
                Erstgespräch
              </router-link>
              <router-link
                  v-else
                  :to="{ name: 'privateCoachingMicFirstInterviewForm', params: { id: coaching.id } }"
                  :class="{ active: $route.name === 'privateCoachingMicFirstInterviewForm' }"
                  class="nav-item nav-link"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false">
                Erstgespräch
              </router-link>
            </div>
          </div>

          <!-- NOT BSG -->
          <div v-if="
              companyKey !== 'BSG' &&
              operationType === 'modular_integration_coaching'">
            <router-link
                v-if="isMICNewLogic"
                :to="{ name: 'bbqPrivateCoachingMicFirstInterviewV2Form', params: { id: coaching.id } }"
                :class="{ active:
                 $route.name === 'bbqPrivateCoachingMicFirstInterviewV2Form' }"
                class="nav-item nav-link"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false">
              Erstgespräch
            </router-link>
          </div>


          <!-- Protocols -->
          <!-- FOR BSG -->
          <div v-if="companyKey === 'BSG'">
            <router-link
                v-if="operationType !== 'modular_integration_coaching' && operationType !== 'go_work_mobile'"
                :to="{ name: 'privateCoachingProtocolList', params: { id: coaching.id } }"
                :class="{ active: $route.name === 'privateCoachingProtocolList' }"
                class="nav-item nav-link"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false">
              Sitzungsprotokolle
            </router-link>

            <router-link
                v-else-if="operationType === 'go_work_mobile'"
                :to="{ name: 'privateCoachingProtocolGoWorkMobileList', params: { id: coaching.id } }"
                :class="{ active: $route.name === 'privateCoachingProtocolGoWorkMobileList' }"
                class="nav-item nav-link"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false">
              Sitzungsprotokolle
            </router-link>

            <div v-if="operationType === 'modular_integration_coaching'">
              <router-link
                  v-if="isMICNewLogic"
                  :to="{ name: 'privateCoachingMICV2List', params: { id: coaching.id } }"
                  :class="{ active: $route.name === 'privateCoachingMICV2List' }"
                  class="nav-item nav-link"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false">
                Sitzungsprotokolle
              </router-link>
              <router-link
                  v-else
                  :to="{ name: 'privateCoachingMICList', params: { id: coaching.id } }"
                  :class="{ active: $route.name === 'privateCoachingMICList' }"
                  class="nav-item nav-link"
                  role="tab"
                  aria-controls="nav-profile"
                  aria-selected="false">
                Sitzungsprotokolle
              </router-link>
            </div>
          </div>

          <!-- NOT BSG -->
          <div v-if="
          companyKey !== 'BSG' &&
          operationType === 'modular_integration_coaching'">
            <router-link
                :to="{ name: 'privateCoachingMICV2List', params: { id: coaching.id } }"
                :class="{ active: $route.name === 'privateCoachingMICV2List' }"
                class="nav-item nav-link"
                role="tab"
                aria-controls="nav-profile"
                aria-selected="false">
              Sitzungsprotokolle
            </router-link>
          </div>

          <router-link
              :to="{ name: 'privateCoachingInterimReportList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'privateCoachingInterimReportList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Zwischenbericht/Stellungnahme
          </router-link>

          <router-link
              :to="{ name: 'privateCoachingFinalInterview', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'privateCoachingFinalInterview' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Abschlussgespräch
          </router-link>

          <router-link
              v-if="currentUserRole !== 'ROLE_COACH' && currentUserRole !== 'ROLE_THERAPIST'"
              :to="{ name: 'privateCoachingIntroductionDocuments', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'privateCoachingIntroductionDocuments' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Dokumente
          </router-link>

          <router-link
              v-if="isDigitalSignature"
              :to="{ name: 'privateCoachingMeetingList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'privateCoachingMeetingList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Anwesenheitsliste monatlich
          </router-link>

          <router-link
              v-if="operationType === 'modular_integration_coaching'"
              :to="{ name: 'privateCoachingModuleList', params: { id: coaching.id } }"
              class="nav-item nav-link"
              :class="{ active: $route.name === 'privateCoachingModuleList' }"
              role="tab"
              aria-controls="nav-contact"
              aria-selected="false">
            Übersicht Modulziele
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>
import {computed, defineProps, onMounted, ref, toRefs} from 'vue';
import {piniaCompanySettingsStore} from "@/store/piniaCompanySettingsStore";

const piniaCompanySettingsState = piniaCompanySettingsStore()
const companySettings = computed(() => piniaCompanySettingsState.companySettings)
const companyKey = companySettings.value.companyKey;

const isMICNewLogic = ref(true);
const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  currentUser: {
    type: Object,
    required: true,
  },
});

const coaching = toRefs(props)['coaching'];
const currentUser = toRefs(props)['currentUser'];
const currentUserRole = currentUser?.value?.roles[0];
const operationType = coaching.value.nameOfCoaching.operationType;
const isDigitalSignature = coaching.value.digitalSignature;
const coachingId = coaching.value.id;

function checkCoachingStartDateForOldLogic() {
  const [day, month, year] = coaching?.value.startDate.split('.'); // e.g., '2024-10-06'
  const coachingStartDate = `${year}-${month}-${day}`;
  const newLogicStartFrom = '2024-10-07'; // Target date in ISO format

  if (coachingId === 9950 || (coachingStartDate < newLogicStartFrom)) {
    isMICNewLogic.value = false;
  }

  // if (coachingStartDate < newLogicStartFrom) {
  //   isMICNewLogic.value = false;
  // }
}

onMounted(() => {
  checkCoachingStartDateForOldLogic();
});
</script>

<style scoped>

</style>